import View from 'view/base';

export default View.extend({
    className: 'screenshot-thumbnail',

    events: {
        'click': 'onSelect'
    },

    dom_handlers: {
        onSelect: function(e) {
            this.dispatcher.trigger('Screenshot_Thumbnail:Select', this.model.id);
        }
    },

    event_handlers: {
        onSelect: function(model_id) {
            if (this.model.id !== model_id) {
                this.$el.removeClass('active');
            } else {
                this.$el.addClass('active');
            }
        }
    },

    initialize: function(options) {
        this.feedback   = options.feedback;
        this.dispatcher = options.dispatcher;

        this.listenTo(this.model, 'change', this.render);

        this.dispatcher.on('Screenshot_Thumbnail:Select', this.event_handlers.onSelect.bind(this));
    },

    onRender: function() {
        var image = new Image();

        image.onload = function() {
            if (image.width / image.height > 2 || image.height / image.width > 2) {
                this.$el.find('.img').addClass('img-cover');
            }

            this.$el.find('.img').css('background-image', 'url(' + this.model.escape('url') + ')');
        }.bind(this);

        image.src = this.model.get('url');
    },

    render: function() {
        var content = '<div class="img"></div>';

        this.$el.html(content);

        this.onRender();

        return this;
    }
});